<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-roles-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupRolesContainerView: () => import('@/components/hris/setup/roles/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup Role',
      }
    },
  }
</script>
